<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div v-if="!paginaEnable">
      <h1 style="display: none">
        Usuário não tem permissão a essa página não existente
      </h1>
    </div>
    <div v-else>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <v-row id="analiseFaturamentoFltrosId">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashboard-filtros
                :primeiro="enablePrimeiroDia"
                :ultimo="enableUltimoDia"
                :empresas="enableEmpresa"
                :url="link"
                :vendedores="enableVendedores"
                :areas="enableAreas"
                :redes="enableRedes"
                :supervisores="enableSupervisores"
                :classificacoes="enableClassificacao"
                :cidades="enableCidades"
                :linha-producao="enableLinhasProducao"
                :produtos="enableProdutos"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="enableBtnPrint"
            id="btnPrint"
            style="margin: 0 0 0 1rem;"
          >
            <v-btn
              class="col-4 col-sm-3 col-md-1 col-lg-1"
              small
              :color="corPrimaria"
              dark
              :loading="imprimindo"
              @click="imprimir()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Imprimir
              <template v-slot:loader>
                <span>Imprimindo...</span>
              </template>
            </v-btn>
          </v-row>
          <br>
          <v-divider class="mb-5" />
          <v-row>
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Como está o faturamento dos meus grupos de itens?
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row id="tableFatClassificacaoMes">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        v-if="loading"
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                      <div
                        v-else-if="error"
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                      <div
                        v-else
                      >
                        <template>
                          <div
                            id="idTable"
                            style="overflow-x: auto;"
                          >
                            <table
                              style="width: 100%; color: black; border-collapse: collapse;"
                              class="elevation-1"
                            >
                              <thead>
                                <tr>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                  />
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('grupo_produto')"
                                  >
                                    Grupo do Produto
                                    <v-icon small>
                                      {{ ordenarDados === 'grupo_produto' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('faturamentoOrdenacao')"
                                  >
                                    Faturamento
                                    <v-icon small>
                                      {{ ordenarDados === 'faturamentoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('volumeOrdenacao')"
                                  >
                                    Volume (litros)
                                    <v-icon small>
                                      {{ ordenarDados === 'volumeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('quantidadeOrdenacao')"
                                  >
                                    Quantidade
                                    <v-icon small>
                                      {{ ordenarDados === 'quantidadeOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('metaOrdenacao')"
                                  >
                                    Meta (litros)
                                    <v-icon small>
                                      {{ ordenarDados === 'metaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('variacaoMetaOrdenacao')"
                                  >
                                    Variação Meta
                                    <v-icon small>
                                      {{ ordenarDados === 'variacaoMetaOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('gapOrdenacao')"
                                  >
                                    GAP
                                    <v-icon small>
                                      {{ ordenarDados === 'gapOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('precoMedioOrdenacao')"
                                  >
                                    Preço Médio / Litros
                                    <v-icon small>
                                      {{ ordenarDados === 'precoMedioOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('faturamentoAnteriorOrdenacao')"
                                  >
                                    Fat. Mês do Ano Anterior
                                    <v-icon small>
                                      {{ ordenarDados === 'faturamentoAnteriorOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('variacaoAnualOrdenacao')"
                                  >
                                    Variação de Fat. Anual
                                    <v-icon small>
                                      {{ ordenarDados === 'variacaoAnualOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;"
                                    @click="mudarOrdenacao('participacaoGrupoOrdenacao')"
                                  >
                                    Participação
                                    <v-icon small>
                                      {{ ordenarDados === 'participacaoGrupoOrdenacao' ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                    </v-icon>
                                  </th>
                                </tr>
                              </thead>
                              <tbody
                                v-for="(item, index) in faturamentoGrupoProdutos"
                                :key="item.id"
                              >
                                <!-- Linha principal -->
                                <tr>
                                  <td style="text-align: center;">
                                    <button @click="toggleExpand(index)">
                                      {{ expanded.includes(index) ? '▲' : '▼' }}
                                    </button>
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left;"
                                  >
                                    {{ item.grupo_produto }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.faturamento }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.volume }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.quantidade }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.meta }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    <v-chip
                                      :color="getColor(item.variacaoMetaOrdenacao)"
                                      dark
                                    >
                                      {{ item.variacaoMeta }}
                                    </v-chip>
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.gap }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.preco_medio }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.faturamento_anterior }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.variacao_anual }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right;"
                                  >
                                    {{ item.participacao_grupo }}
                                  </td>
                                </tr>
                                <!-- Linha expandida -->
                                <tr
                                  v-if="expanded.includes(index)"
                                  :key="'expanded-' + item.id"
                                >
                                  <td colspan="12">
                                    <table
                                      style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('produto', index)"
                                          >
                                            Produto
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'produto' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('unidade', index)"
                                          >
                                            Unidade
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'unidade' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('faturamentoOrdenacao', index)"
                                          >
                                            Faturamento
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'faturamentoOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('volumeOrdenacao', index)"
                                          >
                                            Volume (litros)
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'volumeOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('quantidadeOrdenacao', index)"
                                          >
                                            Quantidade
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'quantidadeOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('precoMedioOrdenacao', index)"
                                          >
                                            Preço Médio/Qtde
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'precoMedioOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('precoMedioLitrosOrdenacao', index)"
                                          >
                                            Preço Médio por litros
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'precoMedioLitrosOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('faturamentoAnteriorOrdenacao', index)"
                                          >
                                            Fat. Mês do Ano Anterior
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'faturamentoAnteriorOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('variacaoAnualOrdenacao', index)"
                                          >
                                            Variação de Fat. Anual
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'variacaoAnualOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                          <th
                                            id="dadoMovimentacaoHeader"
                                            style="text-align: center;"
                                            @click="mudarOrdenacaoProduto('participacaoGrupoOrdenacao', index)"
                                          >
                                            Participação do produto
                                            <v-icon small>
                                              {{ ordenarDadosProdutos === 'participacaoGrupoOrdenacao' ? (ordenacaoDadosProdutosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                                            </v-icon>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          v-for="(sub, idx) in item.dadosProduto"
                                          :key="idx"
                                        >
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: left;"
                                          >
                                            {{ sub.produto }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: left;"
                                          >
                                            {{ sub.unidade }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: right;"
                                          >
                                            {{ sub.faturamento }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: right;"
                                          >
                                            {{ sub.volume }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: right;"
                                          >
                                            {{ sub.quantidade }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: right;"
                                          >
                                            {{ sub.preco_medio }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: right;"
                                          >
                                            {{ sub.precoMedioLitros }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: right;"
                                          >
                                            {{ sub.faturamento_anterior }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: right;"
                                          >
                                            {{ sub.variacao_anual }}
                                          </td>
                                          <td
                                            id="dadoMovimentacao"
                                            style="text-align: right;"
                                          >
                                            {{ sub.participacao_grupo }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </template>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-actions><br><br>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import eventEmit from '../../../components/core/EventoEmit'
  import Produto from '../../../../../services/analiseproduto5'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardDetalheAnaliseProdutos5NaoComercializados',
    emits: [],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../../components/core/FiltroDatas'),
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      produtos: [],
      cidades: [],
      linhasProducao: [],
      headersGrupoProdutos: [
        { text: 'Grupo Produto', value: 'grupo_produto', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', class: 'black--text title' },
        { text: 'Meta', value: 'meta', align: 'right', class: 'black--text title' },
        { text: 'Var. Meta', value: 'variacaoMeta', align: 'right', class: 'black--text title' },
        { text: 'Gap', value: 'gap', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'preco_medio', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês Ano Ante.', value: 'faturamento_anterior', align: 'right', class: 'black--text title' },
        { text: 'Var. Fat. Anual', value: 'variacao_anual', align: 'right', class: 'black--text title' },
        { text: 'Participação', value: 'participacao_grupo', align: 'right', class: 'black--text title' },
      ],
      headersProdutos: [
        { text: 'Produto', value: 'produto', class: 'black--text title' },
        { text: 'Unidade', value: 'unidade', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', align: 'right', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'preco_medio', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio/litros', value: 'precoMedioLitros', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês Ano Ante.', value: 'faturamento_anterior', align: 'right', class: 'black--text title' },
        { text: 'Var. de Fat. Anual', value: 'variacao_anual', align: 'right', class: 'black--text title' },
        { text: 'Participação', value: 'participacao_grupo', align: 'right', class: 'black--text title' },
      ],
      faturamentoGrupoProdutos: [],
      expanded: [],
      ordenarDados: '',
      ordenacaoDadosDecrescente: false,
      ordenarDadosProdutos: '',
      ordenacaoDadosProdutosDecrescente: false,
      paginaEnable: false,
      permissaoAnaliseProduto: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedores: true,
      enableSupervisores: true,
      enableRedes: true,
      enableAreas: true,
      enableBtn: true,
      enableBtnPrint: false,
      loadingBtnPrint: true,
      enableReceita: true,
      enableSegmento: true,
      enableCategoria: true,
      enablePromotor: true,
      enableClassificacao: true,
      enableLinhasProducao: true,
      enableProdutos: true,
      enableCidades: true,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      link: window.location.href,
      imprimindo: false,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 95rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 60rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 10rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 55rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, empresa, vendedor, area, redes, supervisor, receita, segmento, classificacao, produtos, cidades, categoria, promotor, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = empresa
        this.vendedor = vendedor
        this.area = area
        this.rede = redes
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.produtos = produtos
        this.cidades = cidades
        this.linhasProducao = linhasProducao

        this.showFaturamentoGrupoProdutos()
      },

      async showFaturamentoGrupoProdutos () {
        this.loading = true

        this.enableBtnPrint = false

        this.faturamentoGrupoProdutos = []
        this.expanded = []

        this.ordenarDados = ''
        this.ordenacaoDadosDecrescente = false
        this.ordenarDadosProdutos = ''
        this.ordenacaoDadosProdutosDecrescente = false

        await Produto.showAnaliseFaturamentoLitrosGrupoProdutos(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.rede, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.produtos, this.cidades, this.linhasProducao).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoGrupoProdutos = resposta.data.faturamento.map((item) => {
              var listaFaturamento = ({
                grupo_produto: item.grupo_produto,
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamentoOrdenacao: parseFloat(item.faturamento),
                faturamento_anterior: item.faturamento_anterior ? parseFloat(item.faturamento_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
                faturamentoAnteriorOrdenacao: parseFloat(item.faturamento_anterior),
                variacao_anual: item.variacao_anual ? parseFloat(item.variacao_anual).toFixed(2) + '%' : '-',
                variacaoAnualOrdenacao: parseFloat(item.variacao_anual),
                participacao_grupo: item.participacao ? parseFloat(item.participacao).toFixed(2) + '%' : '-',
                participacaoGrupoOrdenacao: parseFloat(item.participacao),
                quantidade: item.quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                quantidadeOrdenacao: item.quantidade,
                volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                volumeOrdenacao: parseFloat(item.volume),
                preco_medio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                precoMedioOrdenacao: parseFloat(item.precoMedio),
                meta: item.meta.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                metaOrdenacao: item.meta,
                gap: item.gap.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                gapOrdenacao: item.gap,
                variacaoMeta: item.variacaoVolume.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                variacaoMetaOrdenacao: item.variacaoVolume,
                expandir: item.expandir,
                dadosProduto: this.dadosProdutos(item.dadosProdutos),
              })

              return listaFaturamento
            })

            eventEmit.$emit('set-dados-grupo-produto', this.faturamentoGrupoProdutos)
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado') {
            this.faturamentoGrupoProdutos = []
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.enableBtnPrint = true
        })
      },

      dadosProdutos (value) {
        const dados = value.map((item) => {
          var listaDados = ({
            produto: item.grupo_produto,
            unidade: item.unidade,
            faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            faturamentoOrdenacao: parseFloat(item.faturamento),
            faturamento_anterior: item.faturamento_anterior ? parseFloat(item.faturamento_anterior).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
            faturamentoAnteriorOrdenacao: parseFloat(item.faturamento_anterior),
            variacao_anual: item.variacao_anual ? parseFloat(item.variacao_anual).toFixed(2) + '%' : '-',
            variacaoAnualOrdenacao: parseFloat(item.variacao_anual),
            participacao_grupo: item.participacao ? parseFloat(item.participacao).toFixed(2) + '%' : '-',
            participacaoGrupoOrdenacao: parseFloat(item.participacao).toFixed(2),
            quantidade: parseFloat(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            quantidadeOrdenacao: parseFloat(item.quantidade),
            volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            volumeOrdenacao: parseFloat(item.volume),
            preco_medio: parseFloat(item.precoMedio).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            precoMedioOrdenacao: parseFloat(item.precoMedio),
            precoMedioLitros: parseFloat(item.precoMedioLitros).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            precoMedioLitrosOrdenacao: parseFloat(item.precoMedioLitros),
          })

          return listaDados
        })

        return dados
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      getColor (value) {
        if (value < 0) {
          return 'red'
        } else {
          return 'green'
        }
      },

      mudarOrdenacao (campo) {
        if (this.ordenarDados === campo) {
          this.ordenacaoDadosDecrescente = !this.ordenacaoDadosDecrescente
        } else {
          this.ordenarDados = campo
          this.ordenacaoDadosDecrescente = false
        }

        this.buscarDadosOrdenados()
      },

      buscarDadosOrdenados () {
        const novaOrdenacao = [...this.faturamentoGrupoProdutos]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDados] < b[this.ordenarDados]) result = -1
          if (a[this.ordenarDados] > b[this.ordenarDados]) result = 1

          if (this.ordenacaoDadosDecrescente) result *= -1

          return result
        })

        this.faturamentoGrupoProdutos = novaOrdenacao
      },

      mudarOrdenacaoProduto (campo, index) {
        if (campo === this.ordenarDadosProdutos) {
          this.ordenacaoDadosProdutosDecrescente = !this.ordenacaoDadosProdutosDecrescente
        } else {
          this.ordenarDadosProdutos = campo
          this.ordenacaoDadosProdutosDecrescente = false
        }

        this.ordenarDadosProduto(index)
      },

      ordenarDadosProduto (index) {
        const novaOrdenacao = [...this.faturamentoGrupoProdutos[index].dadosProduto]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarDadosProdutos] < b[this.ordenarDadosProdutos]) result = -1
          if (a[this.ordenarDadosProdutos] > b[this.ordenarDadosProdutos]) result = 1

          if (this.ordenacaoDadosProdutosDecrescente) result *= -1

          return result
        })

        this.faturamentoGrupoProdutos[index].dadosProduto = novaOrdenacao
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Definir a margem esquerda
          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedor.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.area.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.rede.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisor.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Produto(s) Selecionado(s):', this.produtos.map(p => p.produto))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Linha(s) Produção(ões):', this.linhasProducao.map(l => l.linhaProducao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Classificação(ões) Selecionada(s):', this.classificacao.map(c => c.classificacao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(c => c.cidade))

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          posYFiltros += 10

          const titleTableGrupoProduto = 'Como está o faturamento dos meus grupos de itens?'

          pdf.text(titleTableGrupoProduto, 15, posYFiltros)

          posYFiltros += 5

          let previousTableY = posYFiltros

          this.faturamentoGrupoProdutos.forEach((row, index) => {
            const dadosTabelaPrincipal = [
              [row.grupo_produto, row.faturamento, row.volume, row.quantidade, row.meta, row.variacaoMeta, row.gap, row.preco_medio, row.faturamento_anterior, row.variacao_anual, row.participacao_grupo],
            ]

            const tablePrincipal = pdf.autoTable({
              head: [this.headersGrupoProdutos.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosTabelaPrincipal.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index > 1
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 10 },
            })

            previousTableY = tablePrincipal.lastAutoTable.finalY

            const dadosDetalhesProdutos = row.dadosProduto.map(item => [item.produto, item.unidade, item.faturamento, item.quantidade, item.volume, item.preco_medio, item.precoMedioLitros, item.faturamento_anterior, item.variacao_anual, item.participacao_grupo])

            const tableDetalhes = pdf.autoTable({
              head: [this.headersProdutos.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosDetalhesProdutos.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index > 1
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 10 },
            })

            previousTableY = tableDetalhes.lastAutoTable.finalY
          })

          pdf.save('relatorio_analise_produto.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.faturamentoGrupoProdutosPrint = []
          this.faturamentoLinhaPrint = []
          this.headersTableLinha = []
          this.imprimindo = false
        }
      },
    },
  }

</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  .highlighted-item {
    background-color: #2863af;
    padding: 16px;
    color: white;
    margin: -1rem 0 0 0;
  }

  #listItemFaturamentoGrupos {
    margin: -2rem 0 0 -1rem;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }
</style>

<style lang="sass">

</style>
